import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { SegmentedControl } from '@feathr/components';

import * as styles from './PersonStatusSegmentedControl.css';

export type TPersonStatus = 'active' | 'archived';

interface IPersonStatusSegmentedControlProps {
  value: TPersonStatus;
  onChange: (status: TPersonStatus) => void;
  activeCount?: number;
  archivedCount?: number;
  isLoading?: boolean;
  fullWidth?: boolean;
}

function PersonStatusSegmentedControl({
  value,
  onChange,
  activeCount,
  archivedCount,
  isLoading = false,
  fullWidth = true,
}: Readonly<IPersonStatusSegmentedControlProps>): JSX.Element {
  const { t } = useTranslation();

  function handleChange(newValue: string): void {
    onChange(newValue as TPersonStatus);
  }

  const data = [
    {
      label: t('Active'),
      value: 'active',
      count: activeCount,
      disabled: isLoading,
    },
    {
      label: t('Archived'),
      value: 'archived',
      count: archivedCount,
      disabled: isLoading,
    },
  ];

  return (
    <div className={styles.container}>
      <SegmentedControl
        data={data}
        fullWidth={fullWidth}
        name={'person-status-segmented-control'}
        onChange={handleChange}
        useBadgeForCount={true}
        value={value}
      />
    </div>
  );
}

export default PersonStatusSegmentedControl;
